import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { z } from "zod";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { ArrowLeft, FileText } from "lucide-react";

export const Route = createFileRoute("/claims/$id/")({
  component: ClaimDetail,
});

function ClaimDetail() {
  const { id } = useParams({ from: "/claims/$id" });
  const { data, isLoading, error } = useQuery({
    queryKey: ["invoice", id],
    queryFn: () => apiFetch(`/api/billing/invoices/${id}`, { schema: z.any() }).catch(() => null),
  });

  if (isLoading) return <div className="p-6"><Skeleton className="h-32 w-full" /></div>;
  if (error || !data) return <div className="p-6 text-sm text-muted-foreground">Détail non disponible — page détaillée en migration</div>;

  return (
    <div className="space-y-4 p-6">
      <Link to="/claims" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-3 w-3" /> Retour
      </Link>
      <Card>
        <CardHeader>
          <CardTitle>Facture {data.invoiceNumber}</CardTitle>
          <CardDescription>Statut: {data.status} · {(data.totalCents / 100).toFixed(2)} MAD</CardDescription>
        </CardHeader>
        <CardContent>
          <pre className="text-xs text-muted-foreground overflow-auto">{JSON.stringify(data, null, 2)}</pre>
        </CardContent>
      </Card>
    </div>
  );
}
